import { ERROR_CODES } from '@shinetools/errors';

import { getServerErrorCode } from 'common/errors/utils';

export const bicNotValid = (err: unknown) => {
  const errorCode = getServerErrorCode(err);
  return (
    errorCode === ERROR_CODES.TREEZOR_BANKACCOUNT_BIC_NOT_VALID ||
    errorCode === ERROR_CODES.TREEZOR_BANKACCOUNT_BIC_NOT_VALID_2
  );
};
